import React from "react";

import { Button } from "react-bootstrap";
import { Modal } from "../../../ui/Modal";

export default class ChartFillInFormItemDeleteModal extends React.Component {
  render() {
    return (
      <Modal
        size="small"
        show={this.props.deleteModalVisible}
        onHide={this.props.closeDeleteModal}
        actions={
          <div>
            <Button onClick={this.props.closeDeleteModal}>Close</Button>
            <Button
              onClick={() => {
                this.props.deleteItem();
                this.props.closeDeleteModal();
              }}
            >
              Ok
            </Button>
          </div>
        }
        keyboard={false}
      >
        <div>Are you sure you want to delete this fill in form? This action cannot be undone.</div>
      </Modal>
    );
  }
}
